
import { ProductsKeys } from '@/i18n/types/products.types';

export const products: Record<ProductsKeys, string> = {
  products: 'Productos',
  productImage: 'Imagen del producto',
  addToCart: 'Añadir al carrito',
  loadingProducts: 'Cargando productos...',
  noProductsAvailable: 'No hay productos disponibles',
  noProductsMessage: 'No se encontraron productos. Por favor, vuelve más tarde.',
  errorLoadingProducts: 'Error al cargar productos',
  tryAgain: 'Intentar de nuevo',
  cart: 'Carrito',
  securePaymentInfo: 'Información de pago seguro',
  securePaymentDescription: 'Tus pagos son procesados de manera segura por Culqi. Tus datos de tarjeta nunca son almacenados en nuestros servidores.',
  continueShopping: 'Continuar Comprando',
  viewCart: 'Ver Carrito',
  productPrice: 'Precio',
  productDescription: 'Descripción',
};
